import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { ServiceNotAvailableState } from '@lumapps/lumx-states/components/ServiceNotAvailableState';
import { Size } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { DATA_NAMESPACE } from '../../constants';

const CLASSNAME = 'notification-center-error-state';

export type NotificationErrorStateProps = {
    listNotifications(): void;
};

/**
 * Error state for notifications
 */
const NotificationErrorState: React.FC<NotificationErrorStateProps> = ({ listNotifications }) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(DATA_NAMESPACE);
    const { block } = useClassnames(CLASSNAME);

    return (
        <ServiceNotAvailableState
            className={block()}
            shouldShowIcon
            isVerticallyCentered
            iconSize={Size.xl}
            onRetry={() => listNotifications()}
            buttonProps={{
                children: translateKey(GLOBAL.REFRESH),
                ...get({ element: 'button', action: 'refresh' }),
            }}
        />
    );
};

export { NotificationErrorState };
